const languages = [
  { name: 'Español', code: 'es' },
  { name: 'English', code: 'en' },
];

export default languages;
